import { render, staticRenderFns } from "./ProductChipGroup.vue?vue&type=template&id=53658138"
import script from "./ProductChipGroup.vue?vue&type=script&lang=js"
export * from "./ProductChipGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductChipGroup.vue?vue&type=style&index=0&id=53658138&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports